export default __webpack_public_path__ + "static/media/Gloves of the Sanguine Disciple.c6d47a55.jpg";